import { Box, Container, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import OrderSummary from '../components/dashboard/OrderSummary';
import OrderSummary2 from '../components/dashboard/OrderSummary2';
import TodaysCardSell from '../components/dashboard/TodaysCardSell';
import TodaysCashSell from '../components/dashboard/TodaysCashSell';
import TodaysOrders from '../components/dashboard/TodaysOrders';
import TodaysSells from '../components/dashboard/TodaysSells';
import TotalMenu from '../components/dashboard/TotalMenu';
import TotalProducts from '../components/dashboard/TotalProducts';
import TotalSell from '../components/dashboard/TotalSell';
import { DashboardLayout } from '../components/layout/dashboard-layout';



const Dashboard = () => {
    const [alldata, setAlldata] = useState([]);
    useEffect(() => {
        fetch("https://admin.sliceguys.co.uk/buy-product")
            .then((res) => res.json())
            .then((data) => setAlldata(data));
    }, []);

    return (
        <Box
            component="main"
            sx={{
                flexGrow: 1,
                py: 3
            }}
        >
            <Container maxWidth={false}>
                <Grid
                    container
                    spacing={3}
                >
                    <Grid
                        item
                        xl={4}
                        lg={4}
                        sm={6}
                        xs={12}
                    >
                        <TodaysOrders alldata={alldata} />
                    </Grid>
                    <Grid
                        item
                        xl={4}
                        lg={4}
                        sm={6}
                        xs={12}
                    >
                        <TotalMenu></TotalMenu>
                    </Grid>
                    <Grid
                        item
                        xl={4}
                        lg={4}
                        sm={6}
                        xs={12}
                    >
                        <TotalProducts />
                    </Grid>
                    <Grid
                        item
                        xl={3}
                        lg={3}
                        sm={6}
                        xs={12}
                    >
                        <TodaysSells alldata={alldata} />
                    </Grid>
                    <Grid
                        item
                        xl={3}
                        lg={3}
                        sm={6}
                        xs={12}
                    >
                        <TodaysCardSell alldata={alldata} />
                    </Grid>
                    <Grid
                        item
                        xl={3}
                        lg={3}
                        sm={6}
                        xs={12}
                    >
                        <TodaysCashSell alldata={alldata} />
                    </Grid>
                    <Grid
                        item
                        xl={3}
                        lg={3}
                        sm={6}
                        xs={12}
                    >
                        <TotalSell alldata={alldata} />
                    </Grid>
                    <Grid
                        item
                        lg={6}
                        md={6}
                        xs={12}
                    >
                        <OrderSummary alldata={alldata} />
                    </Grid>
                    <Grid
                        item
                        lg={6}
                        md={6}
                        xs={12}
                    >
                        <OrderSummary2 alldata={alldata} />
                    </Grid>

                </Grid>
            </Container>
        </Box>
    );
};
Dashboard.getLayout = (page) => (
    <DashboardLayout>
        {page}
    </DashboardLayout>
);


export default Dashboard;